import { useLocation } from "react-router";
import type { ArticleDataObject } from "@app/types/Cue";
import { BlockTitle } from "@blocks/Blocks";
import LoadMore from "@components/LoadMore/LoadMore";
import EventsAwardsNewsListingStories from "@events-awards/EventsAwardsNewsListingStories";
import {
  AwardType,
  EventsAwardsNewsContextData,
} from "@events-awards/utils/types";
import { useLoadMoreEventsNewsByKeywords } from "@hooks/useLoadMoreEventsNewsByKeywords";
import { compact } from "lodash-es";

/**
 * Component to render news section on News page for event and awards
 */
const EventsAwardsNews = ({
  articles,
  awardType,
}: EventsAwardsNewsContextData): React.ReactElement => {
  const matchedCategory = useLocation().pathname.replace("/", "");

  const isSIAAward = awardType === AwardType.SIA;
  const [parentCategory = "", childCategory = ""] = matchedCategory.split("/");
  const uniqueCategoryQuery = compact([
    parentCategory !== "keywords" && parentCategory,
    childCategory,
  ]).join("_");

  const { articleList, handleLoadMore, hasMoreArticles } =
    useLoadMoreEventsNewsByKeywords(
      articles,
      10,
      uniqueCategoryQuery,
      parentCategory
    );

  return (
    <section data-testdata-testid="events-news-component">
      {isSIAAward ? (
        <BlockTitle
          text="News"
          rootClassName="font-poppins text-lg font-bold text-gray-850 lg:text-3xl mb-5"
        />
      ) : null}

      <div className="stories">
        {articleList.map((article: ArticleDataObject, index: number) => {
          return (
            <EventsAwardsNewsListingStories
              key={index}
              index={index}
              article={article}
              awardType={awardType}
            />
          );
        })}
      </div>

      {hasMoreArticles ? (
        <LoadMore
          rootClassName="my-4"
          onLoadMore={handleLoadMore}
          hasMore={hasMoreArticles}
        />
      ) : null}
    </section>
  );
};

export default EventsAwardsNews;
